// frontend/src/pages/Assignments.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// import MainLayout from '../../layouts/MainLayout';
import './styles/AssignmentTopics.css';
import OtherAssignmentTopics from './OtherAssignmentTopics';
import MyOtherAssignmentsList from './MyOtherAssignmentsList';

const AssignmentOthers = () => {
  const [showAssignments, setShowAssignments] = useState(false);

  const handleShowAssignments = () => {
    setShowAssignments(!showAssignments);
  };

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black text-white py-2">
      <div className='border-b border-blue-400 mb-2'>
        <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
          📖 DIY Assignments
        </h2>
      </div>
      <OtherAssignmentTopics/>
      <div className="m-auto my-2 p-2 w-full">
        <button className="text-white text-center bg-green-800 mt-2 ml-4 mr-4" onClick={handleShowAssignments}>
          {showAssignments ? 'Hide My Assignments' : 'Show My Assignments'}
        </button>
      </div>
      {showAssignments && <MyOtherAssignmentsList />}
      {/* </div> */}
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>  
    </div>
  );
};

export default AssignmentOthers;





